import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=3dc40106&scoped=true&"
import script from "./CreateCourse.vue?vue&type=script&lang=js&"
export * from "./CreateCourse.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourse.vue?vue&type=style&index=0&id=3dc40106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc40106",
  null
  
)

export default component.exports